import { connect } from 'react-redux';
import { compose } from 'redux';
import _ from 'underscore';

import { withRouter } from 'react-router-dom';
import withRoutes from './withRoutes';

const getRouteProps = (routes, pathname) => {
  let route = {};
  _.each(routes, (currentRoute) => {
    if (currentRoute.path === pathname) {
      route = { ...currentRoute };
    }
  });
  return route;
};

const mapStateToProps = ({ ScreensData = {} }, { routes = {}, location = {} }) => {
  const route = getRouteProps(routes, location.pathname);
  return {
    ...ScreensData,
    currentForm: route.props.form,
    formScreen: route.props.formScreen,
  };
};

export default (WrappedComponent) => compose(
  withRouter,
  withRoutes,
  connect(mapStateToProps, {}),
)(WrappedComponent);
